import { Button, Modal, ModalClose, ModalDialog, Stack, Typography } from '@healthinal/ui';
import { ReactNode } from 'react';

export function WarningConfirmationModal({
  open,
  title,
  children,
  loading,
  confirmLabel = 'Ja',
  cancelLabel = 'Nein',
  onCancel,
  onConfirm,
}: {
  open: boolean;
  title: string;
  children: ReactNode;
  loading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}) {
  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog sx={{ width: 500 }}>
        <ModalClose />
        <Typography level="h4">{title}</Typography>
        <Stack gap={2}>
          <Stack>{children}</Stack>
          <Stack direction="row" justifyContent="flex-end" gap={2} mt={1}>
            <Button variant="outlined" color="neutral" onClick={onCancel}>
              {cancelLabel}
            </Button>
            <Button loading={loading} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
